/** OAuth providers displayed on the auth page */
export type OAuthProvider = "github" | "google" | "gitlab" | "bitbucket";

/** Providers that have backend support — getOauthUrl will be called */
export const SUPPORTED_OAUTH_PROVIDERS: OAuthProvider[] = ["github", "google", "gitlab"];

/** Auth error from GraphQL or network failure */
export interface AuthError {
  code: string;
  messageKey: string; // i18n key
}

/** View states of the auth form */
export type AuthView = "form" | "sent" | "error";

/** Provider metadata for rendering buttons */
export interface OAuthProviderConfig {
  id: OAuthProvider;
  name: string; // Display name (brand proper noun, not i18n — never translated)
  icon: string; // lucide-react icon name or custom SVG identifier
  supported: boolean; // whether backend can handle this provider
}

/** Static list of all providers in display order */
export const OAUTH_PROVIDERS: OAuthProviderConfig[] = [
  { id: "github", name: "GitHub", icon: "github", supported: true },
  { id: "google", name: "Google", icon: "google", supported: true },
  { id: "gitlab", name: "GitLab", icon: "gitlab", supported: true },
  { id: "bitbucket", name: "Bitbucket", icon: "bitbucket", supported: false },
];
